import React from 'react';
import PropTypes from 'prop-types';
import BookingsList from './BookingsList';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import translate from 'components/hoc/translate';

const BookingsListContainer = (props) => {
    const initialFilters = {
        reservation_status: {
            matchType: filterMatchTypes.matchOneOf,
            value: [
                'completed',
                'under_review',
            ],
        },
    };

    /**
     * @todo move the Header Title and Actions Component to this page.
     */
    return (
        <div>
            <BookingsList
                { ...props }
                initialFilters={ initialFilters }
            />
        </div>
    );
};

BookingsListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(BookingsListContainer);



// WEBPACK FOOTER //
// ./src/pages/bookings/list/BookingsListContainer.js